import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Range from 'vux/src/components/range/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import * as $ from 'jquery'
import * as THREE from 'three'
var STLLoader = require('three-stl-loader')(THREE)
import AsciiEffect from 'three-asciieffect'
import TrackballControls from 'three-trackballcontrols'
import login from '../login/login'
import { mapGetters, mapActions } from 'vuex'


export default {
name: 'commodity',
directives: {
TransferDom
},
components: {
Swiper,
SwiperItem,
Range,
XButton,
Rater,
XDialog,
Confirm,
Loading,
Actionsheet
},
data () {
return {
objData: {
coverImgUrl: '',
},
reverse: false,
swiperIndex: 0,
loginShow: false,
showSwiperBox: false,
activeColor: 0,
rangeBar: 100,
minRange: 50,
maxRange: 200,
raterValue: 0,
showMaterialsDialog: false,
defaultColor: '',
materialsDatas: [],
newListRealImgs: [],
activeIndex: 0,
ClickColorAfter: false,
bulk: '',
len: '',
width: '',
height: '',
commentNum: 0,
haveComment: false,
commenter: '',
isCollect: false,
showConfirm: false,
confirmContent: '',
confirmText: '',
cancelText: '',
confirmEvent: '',
confirmImg: '',
showPreview: false,
controls:'',//3D预览控制器
showPreviewLoading: false,
bigImgList: [],
bindSmallImg: 0,
showShare: false,
buyFlag: '',
showVideoImgBox: false,
videoImgIndex: -1,
showNoWifiHintDialog: false,
showToggleImg: true,
showErrConfirm: false,
shareMenus: {
menu1: '微信好友',
menu2: 'QQ好友',
menu3: 'QQ空间',

}
}
},
methods: {
...mapGetters ([
'getterWifiFirstHintState'
]),

loginCallback(status, response) {
console.log(status)
console.log(response)

if(response.code == 0) {
this.$vux.toast.show({
type: 'success',
text: '登录成功'
})
setTimeout(()=>{
if(this.buyFlag == 'addCart'){
this.addCart()
}else if(this.buyFlag == 'buyNow'){
this.buyNow()
}
},651)
}
},
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},
toggleVideoImgBox (type) {
if(type == 'video'){
this.videoImgIndex = 0
this.reverse = false
this.bindSmallImg = 0
this.swiperIndex = 0
this.showToggleImg = false
this.showSwiperBox = false
}else{

this.videoImgIndex = 1
this.bindSmallImg = 1
this.showToggleImg = true
}
},
swiperIndexChange (currentIndex) {
console.log(currentIndex)
if(this.objData.videoPath){
if(currentIndex == 0){
this.videoImgIndex = 0
this.showToggleImg = false
this.showSwiperBox = false
}else{

this.videoImgIndex = 1
this.showToggleImg = true
}
}
},
toggleImg () {  //切换显示隐藏小图片
this.reverse = !this.reverse
this.showSwiperBox = !this.showSwiperBox
this.videoImgIndex = 1
if(this.reverse){
if(this.objData.videoPath){
this.bindSmallImg = 2
}else{
this.bindSmallImg = 1
}
}else{
this.swiperIndex = 0
if(this.objData.videoPath){
this.bindSmallImg = 1

}else{
this.bindSmallImg = 0
}
}
},
playVideo (objData) {


this.$router.push({
path: '/fullScreenVideo',
query: {
videoUrl: objData.videoPath
}
})




},
subtractSwiperIndex () {  //轮播上一页
if(this.newListRealImgs.length > 1){
this.swiperIndex -= 1
}
},
addSwiperIndex () {  //轮播下一页
if(this.newListRealImgs.length > 1){
this.swiperIndex += 1
}
},
changeRange () {  //大小(滑块滑动)

this.objData.bulk = Math.floor((this.bulk * this.rangeBar / 100) * 100) / 100
this.objData.len = Math.floor((this.len * this.rangeBar / 100) * 100) / 100
this.objData.width = Math.floor((this.width * this.rangeBar / 100) * 100) / 100
this.objData.height = Math.floor((this.height * this.rangeBar / 100) * 100) / 100
},
resetRange () {   //重置大小
this.rangeBar = 100
this.getPriceByZoom(1)
},
selectColor (item,index) {  //点击颜色
this.showSwiperBox = false
this.reverse = false
console.log(JSON.parse(JSON.stringify(item)))
let clickMaterialsDatas = this.objData.listSkus.filter((item2, index2) => {  //点击颜色时，判断id相同，渲染dialog
return item2.colorId == item.colorId
})
console.log(clickMaterialsDatas)
this.ClickColorAfter = true
this.materialsDatas = clickMaterialsDatas
this.defaultColor = item
this.defaultColor.salePrice = item.salePrice
console.log(JSON.parse(JSON.stringify(this.defaultColor)))
this.activeColor = index
this.activeIndex = 0
let clickColor = this.objData.listImgs.filter((item3, index3) => {  //点击颜色时，判断id相同，渲染大图
return item3.colorId == item.colorId
})
this.objData.imagePath = clickColor[0].imagePath
this.bigImgList[0] = clickColor[0].imagePath
this.bindSmallImg = 0
},
selectMaterials (item,index) {   //选择材料后
this.activeIndex = index
this.defaultColor = item
this.defaultColor.salePrice = item.salePrice
console.log(JSON.parse(JSON.stringify(this.defaultColor)))
setTimeout(() => {
this.showMaterialsDialog = false
}, 150);
},
backProductList () {
this.$router.push({
path: '/shop'
})
},
getDetail () {  //获取商品详情的请求
this.$request.post('/product/detail',{
id: this.$route.query.id
}).then(data => {
if(data.code == 0){
if(data.obj.listSkus.length == 0){
this.showErrConfirm = true
return false;
}
let obj = data.obj
this.bulk = obj.bulk
this.len = obj.len
this.width = obj.width
this.height = obj.height
this.objData = obj
var newObj = {};
this.objData.listSkus2 = this.objData.listSkus.reduce(function(item, next) {
newObj[next.colorName] ? '' : newObj[next.colorName] = true && item.push(next);
return item;
}, [])
console.log(JSON.parse(JSON.stringify(this.objData)))
this.defaultColor = this.objData.listSkus[0]
this.materialsDatas = this.objData.listSkus
if(this.objData.videoPath){
this.showVideoImgBox = true
this.videoImgIndex = 0
this.bigImgList.push(this.objData.videoPath)
this.showToggleImg = false
}
this.bigImgList.push(this.objData.imagePath)
this.objData.listRealImgs.forEach((item, index) => {
this.bigImgList.push(item.imagePath)
})
for(var i=0; i<this.objData.listRealImgs.length; i++){
if(this.objData.listRealImgs.length != 0){
this.newListRealImgs.push(this.objData.listRealImgs.splice(0,5))
}
}
console.log(JSON.parse(JSON.stringify(this.bigImgList)))
console.log(JSON.parse(JSON.stringify(this.newListRealImgs)))
var u = navigator.userAgent,
goLink = '';
if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
goLink = window.location.href
}else{
goLink = window.location.href.replace('#','?isappinstalled=0#')
}

this.$shareList(obj.imagePath, goLink, obj.detail, obj.spuName)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})


this.$request.post('/product/myfavorite',{
spuId: this.$route.query.id,
token: this.getCookie('_token'),
}).then(data => {
if(data.code == 0){
if(data.obj.result == '1'){
this.isCollect = true
}else{
this.isCollect = false
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})


this.$request.post('/comment/listComment',{
spuId: this.$route.query.id,
page: 1,
rows: 1
}).then(data => {
if(data.code == 0){
this.commentNum = data.obj.total
if(data.obj.total != 0){
this.commenter = data.obj.rows[0]
this.haveComment = true
}
console.log(data)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getPriceByZoom (value) {  //计算后重新获取单价
this.$request.post('/product/getPriceByZoom',{
spuId: this.$route.query.id,
zoom: value
}).then(data => {
if(data.code == 0){
this.objData.listSkus = data.obj.listSkus

if(this.ClickColorAfter){
let clickMaterialsDatas = data.obj.listSkus.filter((item2, index2) => {  //点击颜色时，判断id相同，渲染dialog
return item2.colorId == this.defaultColor.colorId
})
console.log(clickMaterialsDatas)
this.materialsDatas = clickMaterialsDatas
let clickColor = this.objData.listImgs.filter((item3, index3) => {  //点击颜色时，判断id相同，渲染大图
return item3.colorId == this.defaultColor.colorId
})
this.objData.imagePath = clickColor[0].imagePath
}else{
this.materialsDatas = data.obj.listSkus
}

var newObj = {};
this.objData.listSkus2 = data.obj.listSkus.reduce(function(item, next) {
newObj[next.colorName] ? '' : newObj[next.colorName] = true && item.push(next);
return item;
}, [])
console.log(JSON.parse(JSON.stringify(this.materialsDatas[this.activeIndex])))
this.defaultColor.salePrice = this.materialsDatas[this.activeIndex].salePrice

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
clickMaterialImg (item, index) { //点击实物图
this.objData.imagePath = item.imagePath
if(this.objData.videoPath){
this.bindSmallImg = (index + 2) + (this.swiperIndex * 5)
}else{
this.bindSmallImg = (index + 1) + (this.swiperIndex * 5)
}
console.log(this.swiperIndex * 5)
console.log(this.newListRealImgs.length)
},
touchendRange () {  //获取单价
let zoom = this.rangeBar/100
this.getPriceByZoom(zoom)
},
addCollect () { //加入收藏
console.log(this.$common.getCookie('_token'))
if(!this.$common.getCookie('_token')){
this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
})
return false;
}
this.$request.post('/favorite/add',{
spuId: this.$route.query.id,
token: this.getCookie('_token'),
}).then(data => {
if(data.code == 0){
this.isCollect = true
this.$vux.toast.show({
type: 'success',
text: '已加入收藏'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
removeCollect () { //取消收藏
console.log(this.$common.getCookie('_token'))
if(!this.$common.getCookie('_token')){
this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
})
return false;
}
this.showConfirm = true
this.confirmContent = '确定取消收藏吗？'
this.confirmText = '确定'
this.cancelText = '取消'
this.confirmEvent = 'removeCollect'
this.confirmImg = require('../../assets/images/redWarn.png')
},
addCart () {  //加入购物车
this.buyFlag = 'addCart'
console.log(this.$common.getCookie('_token'))
if(!this.$common.getCookie('_token')){






this.loginShow = true
return false;
}
let zoom = this.rangeBar/100
this.$request.post('/cart/add',{

token: this.getCookie('_token'),
skuId: this.defaultColor.id,
qty: 1,
zoom: zoom
}).then(data => {
if(data.code == 0){
this.showConfirm = true
this.confirmContent = '添加购物车成功'
this.confirmText = '去购物车'
this.cancelText = '继续购物'
this.confirmEvent = 'addCart'
this.confirmImg = require('../../assets/images/circleSuccess.png')
if(this.loginShow) {
this.$router.push({
path: '/shoppingCart',
query: {
type: 'productCenter'
}
})
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
soldOut () {
this.$vux.toast.show({
type: 'warn',
text: '该商品已下架'
})
},
buyNow () { //立即购买
this.buyFlag = 'buyNow'
console.log(this.$common.getCookie('_token'))
if(!this.$common.getCookie('_token')){






this.loginShow = true
return false;
}
let zoom = this.rangeBar/100
this.$request.post('/cart/buynow',{

token: this.getCookie('_token'),
skuId: this.defaultColor.id,
qty: 1,
zoom: zoom
}).then(data => {
if(data.code == 0){
this.$router.push({
path: '/submitOrder',
query: {
cartType: 'cartdirect',
type: 'productCenter'
}
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
onCancel () {
if(this.confirmEvent == 'removeCollect'){ //取消加入收藏
this.showConfirm = false
}else if(this.confirmEvent == 'addCart'){ //继续购物
this.showConfirm = false
}
},
onConfirm () {    //确定
if(this.confirmEvent == 'removeCollect'){ //确定取消收藏
this.$request.post('/favorite/deleteById',{
spuId: this.$route.query.id,
token: this.getCookie('_token'),
}).then(data => {
if(data.code == 0){
this.isCollect = false
this.$vux.toast.show({
type: 'success',
text: '已取消收藏'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmEvent == 'addCart'){ //去购物车
this.$router.push({
path: '/shoppingCart',
query: {
type: 'productCenter',
}
})
}
},
moreWorks () {
this.$router.push({
path: '/stylistStore',
query: {
designerId: this.objData.designerId
}
})
},
copy (str) {
var save = function(e){
e.clipboardData.setData('text/plain',str);
e.preventDefault();
}
document.addEventListener('copy',save);
document.execCommand('copy');
document.removeEventListener('copy',save);
},
share (key, value) {
var ua = navigator.userAgent.toLowerCase();
if(ua.match(/MicroMessenger/i)=="micromessenger") { //微信自带浏览器
alert('点击右上角即可分享')
} else {  //非微信自带浏览器
if(value == '微信好友'){
this.$vux.toast.show({
type: 'success',
text: '复制成功，去粘贴分享给微信好友吧'
})
this.copy(location.href)
setTimeout(() => {
window.location.href = 'weixin://';
}, 1000);
}else if(value == 'QQ好友'){
this.$vux.toast.show({
type: 'success',
text: '复制成功，去粘贴分享给QQ好友吧'
})
this.copy(location.href)
setTimeout(() => {
window.location.href = 'mqqwpa://im/chat?chat_type=wpa&version=1&src_type=web&web_src=oicqzone.com';
}, 1000);
}else if(value == 'QQ空间'){
var shareUrl = encodeURIComponent(location.href),              //链接
shareTitle = encodeURIComponent(this.objData.spuName),    //标题
shareImg = encodeURIComponent(this.objData.imagePath),   //图片
shareMs = encodeURIComponent(this.objData.detail),      //描述
share = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='+shareUrl+'&sharesource=qzone&title='+shareTitle+'&pics='+shareImg+'&summary='+shareMs+''
window.location.href = share
}else if(value == '微博'){
alert('微博')
}
}
console.log(value)
},
changeWifiFirstHintState (type) {
if(type == '继续'){
this.$store.dispatch('actionsWifiFirstHintState',false)
this.showNoWifiHintDialog = false
this.showPreviewLoading = true
this.showPreview = true
this.fileScanner(this.objData.ossKeyStl)
$('.previewBox canvas').hide();
$($('.previewBox canvas')[0]).show();
}else{
this.showNoWifiHintDialog = false
}
},
preview () {
const u = navigator.userAgent;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
if (isiOS) {
this.showPreviewLoading = true
this.showPreview = true
this.fileScanner(this.objData.ossKeyStl)
$('.previewBox canvas').hide();
$($('.previewBox canvas')[0]).show();
} else {
if(this.getterWifiFirstHintState() && navigator.connection.type != 'wifi'){

this.showNoWifiHintDialog = true
}else{
this.showPreviewLoading = true
this.showPreview = true
this.fileScanner(this.objData.ossKeyStl)
$('.previewBox canvas').hide();
$($('.previewBox canvas')[0]).show();
}
}





},
closePreview () {
$('.previewBox').html('')
this.showPreview = false
},

fileScanner(filePath) {
var WIDTH, HEIGHT;
var renderer;

function initThree() {

WIDTH = 375;
HEIGHT = 375;
/* 渲染器 */
renderer = new THREE.WebGLRenderer({
antialias: true, //是否开启反锯齿
precision: "highp", //着色精度选择
alpha: true, //是否可以设置背景色透明
premultipliedAlpha: false,
stencil: false,
preserveDrawingBuffer: true, //是否保存绘图缓冲
maxLights: 8 
});
renderer.setSize(WIDTH, HEIGHT);

renderer.setClearColor(new THREE.Color('#f4f4f4'));
renderer.gammaInput = true;
renderer.gammaOutput = true;



console.log(renderer.domElement);











}

/* 设置摄像头 */
var camera;

function initCamera() {
var VIEW_ANGLE = 45,
ASPECT = WIDTH / HEIGHT,
NEAR = 1,
FAR = 10000;

camera = new THREE.PerspectiveCamera(VIEW_ANGLE, ASPECT, NEAR, FAR);

camera.position.set(50, 0, 0);
camera.up.set(0, 0, 1)

camera.lookAt(300, 0, 0);






}

/* 场景 */
var scene;

function initScene() {
scene = new THREE.Scene();


}

/* 灯光 */
var light, light2, light3;

function initLight() {

light = new THREE.DirectionalLight(0xFFFFFF);
light.position.set(0, 99, 0).normalize();
scene.add(light);



light2 = new THREE.AmbientLight(0x999999);
scene.add(light2);

light3 = new THREE.PointLight(0xFFFFFF);
light3.position.set(250, -200, 100);
scene.add(light3);







}

/* 显示对象 */
var cube;

var initObject = () => {



var stlloader = new STLLoader();





var geometry = new THREE.Geometry(260, 35, 185, 1, 1, 1)




stlloader.load(filePath, (geometry) => {
















var material1 = new THREE.MeshLambertMaterial({
ambient: '#4a90ea',
color: '#4a90ea',
specular: '#fff',
shininess: 200
});


var mat = new THREE.MeshLambertMaterial({
color: 0xFFD700
});
var mesh = new THREE.Mesh(geometry, material1)
console.log(geometry);


geometry.center();

mesh.rotation.set(0, 0, 1.55);

mesh.position.set(0, 0, 0);

var originalx = geometry.boundingBox.max.x;
var originaly = geometry.boundingBox.max.y;
var originalz = geometry.boundingBox.max.z;
console.log(originalx, originaly, originalz);


var originalmax = Math.max(originalx, originaly, originalz);






if (geometry instanceof THREE.BufferGeometry) {
geometry = new THREE.Geometry().fromBufferGeometry(geometry);


}



var volume = 0;
var volumes = 0;
var Area = 0;

for (let f = 0, fl = geometry.faces.length; f < fl; f++) {
var face = geometry.faces[f];
var vA = geometry.vertices[face.a];
var vB = geometry.vertices[face.b];
var vC = geometry.vertices[face.c];

var x1 = vA.x,
x2 = vB.x,
x3 = vC.x;
var y1 = vA.y,
y2 = vB.y,
y3 = vC.y;
var z1 = vA.z,
z2 = vB.z,
z3 = vC.z;

var V = (-x3 * y2 * z1 + x2 * y3 * z1 + x3 * y1 * z2 - x1 * y3 * z2 - x2 * y1 * z3 + x1 * y2 * z3) / 6;
volume += V;

}


function volumeOfT(p1, p2, p3) {
var v321 = p3.x * p2.y * p1.z;
var v231 = p2.x * p3.y * p1.z;
var v312 = p3.x * p1.y * p2.z;
var v132 = p1.x * p3.y * p2.z;
var v213 = p2.x * p1.y * p3.z;
var v123 = p1.x * p2.y * p3.z;
return (-v321 + v231 + v312 - v132 - v213 + v123) / 6.0;
}

function AreaOfTriangle(p1, p2, p3) {
var ax = p2.x - p1.x;
var ay = p2.y - p1.y;
var az = p2.z - p1.z;
var bx = p3.x - p1.x;
var by = p3.y - p1.y;
var bz = p3.z - p1.z;
var cx = ay * bz - az * by;
var cy = az * bx - ax * bz;
var cz = ax * by - ay * bx;
return (0.5 * Math.sqrt(cx * cx + cy * cy + cz * cz));
}

for (var i = 0; i < geometry.faces.length; i++) {
var Pi = geometry.faces[i].a;
var Qi = geometry.faces[i].b;
var Ri = geometry.faces[i].c;
var P = new THREE.Vector3(geometry.vertices[Pi].x, geometry.vertices[Pi].y, geometry.vertices[Pi].z);
var Q = new THREE.Vector3(geometry.vertices[Qi].x, geometry.vertices[Qi].y, geometry.vertices[Qi].z);
var R = new THREE.Vector3(geometry.vertices[Ri].x, geometry.vertices[Ri].y, geometry.vertices[Ri].z);
volumes += volumeOfT(P, Q, R); 

Area += AreaOfTriangle(R, Q, P);
}

console.log(geometry);
console.log('体积1:' + Math.abs(volumes));
console.log('体积2:' + Math.abs(volume));
console.log('表面积：' + Area);
console.log('长' , geometry.boundingBox.max.x + Math.abs(geometry.boundingBox.min.x));
console.log('宽' , geometry.boundingBox.max.y + Math.abs(geometry.boundingBox.min.y));
console.log('高' , geometry.boundingBox.max.z + Math.abs(geometry.boundingBox.min.z));

let length = Math.ceil(geometry.boundingBox.max.x + Math.abs(geometry.boundingBox.min.x))
let width = Math.ceil(geometry.boundingBox.max.y + Math.abs(geometry.boundingBox.min.y))
let height = Math.ceil(geometry.boundingBox.max.z + Math.abs(geometry.boundingBox.min.z))




document.querySelector('.previewBox').append(renderer.domElement)
this.showPreviewLoading = false

this.$nextTick(function() {
this.controls.handleResize();
this.controls.screen.left = 0;
})



setTimeout(()=>{



},3000)



var arg = 15 / originalmax;


mesh.scale.set(arg, arg, arg);

scene.add(mesh)

var canvasUrl = renderer.domElement.toDataURL("image/png");




},

function (xhr) {



if ((xhr.loaded / xhr.total * 100) + '% loaded' === '100% loaded') {

}
},








)


}


var effect;
var controls;

var _this = this;
function initControl() {
effect = new AsciiEffect(renderer);
effect.setSize(WIDTH, HEIGHT);
controls = new TrackballControls(camera, renderer.domElement);

controls.minDistance = 30;

controls.maxDistance = 150;

_this.controls = controls
}


function animate() {
requestAnimationFrame(animate);
controls.update();
effect.render(scene, camera);
}


function threeStart() {

initThree();
initScene();

initCamera();
initLight();

initObject();
initControl();
animate();
}

threeStart();
},
},
created () {
this.getDetail()
},
mounted() {



































































},
}



// WEBPACK FOOTER //
// ./src/views/commodity/script.js